import { isApproval } from '../../helpers/matchers'

export const shouldRenderApprovalButton = (phase) => {
  const isInactiveCurrentPhase =
    !phase.is_complete && phase.is_current && !phase.is_active
  return isApproval(phase.phase_type) && isInactiveCurrentPhase
}

export const itemListTitle = (otherProps) => {
  if (isApproval(otherProps.phase_type)) {
    if (otherProps.is_active) {
      const approvalsNeeded = otherProps.requires_all_approvals
        ? 'all approvals needed'
        : 'one approval needed'
      return `Approvals sent, ${approvalsNeeded}`
    }

    if (otherProps.is_complete) {
      const approvalsNeeded = otherProps.requires_all_approvals
        ? 'All approvals needed, '
        : 'One approval needed, '
      const startType = otherProps.autostart
        ? 'started automatically'
        : 'started manually'
      return approvalsNeeded + startType
    }

    const approvalsNeeded = otherProps.requires_all_approvals
      ? 'All approvals needed, '
      : 'One approval needed, '
    const startType = otherProps.autostart
      ? 'starts automatically'
      : 'starts manually'
    return approvalsNeeded + startType
  }

  return null
}

export const markLastIncompleteItem = (items) => {
  const incompleteItems = items.filter(
    (item) => item.status !== 'complete' && item.id
  )
  const completedAndPlaceholderItems = items.filter(
    (item) => item.status === 'complete' || !item.id
  )

  if (incompleteItems.length === 1) {
    incompleteItems[0].isLastIncompleteItem = true
    return [incompleteItems[0], ...completedAndPlaceholderItems]
  }
  return items
}
